import axios from "axios";
 
// Cloudinary configuration from environment variables
const CLOUDINARY_CLOUD_NAME = process.env.REACT_APP_CLOUDINARY_CLOUD_NAME;
const CLOUDINARY_UPLOAD_PRESET = process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET;
 
/**
 * Upload file to Cloudinary
 * @param {File} file - The file to upload
 * @param {string} resourceType - The type of resource ('image', 'video', 'raw')
 * @param {number} maxSizeMB - Maximum file size in MB
 * @returns {Promise<string>} - The secure URL of the uploaded file
 */
export const uploadToCloudinary = async (
  file,
  resourceType = "raw",
  maxSizeMB = 10
) => {
  if (!file) {
    throw new Error("No file provided");
  }
 
  // Validate file size
  const maxSize = maxSizeMB * 1024 * 1024;
  if (file.size > maxSize) {
    throw new Error(`File size exceeds ${maxSizeMB}MB limit`);
  }
 
  const formData = new FormData();
  formData.append("file", file);
  formData.append("upload_preset", CLOUDINARY_UPLOAD_PRESET);
  formData.append("public_id", file.name);
 
  try {
    const response = await axios.post(
      `https://api.cloudinary.com/v1_1/${CLOUDINARY_CLOUD_NAME}/${resourceType}/upload`,
      formData
    );
 
    return response.data.secure_url;
  } catch (error) {
    console.error("Cloudinary upload error:", error);
    throw new Error("Failed to upload file to Cloudinary");
  }
};
 
/**
 * Upload image to Cloudinary
 * @param {File} file - The image file to upload
 * @param {string} folder - Optional folder path (deprecated in this version)
 * @returns {Promise<string>} - The secure URL of the uploaded image
 */
export const uploadImageToCloudinary = async (
  file,
  folder = "skillsmd/avatars"
) => {
  return uploadToCloudinary(file, "image", 10);
};
 
/**
 * Upload document to Cloudinary
 * @param {File} file - The document file to upload
 * @returns {Promise<string>} - The secure URL of the uploaded document
 */
export const uploadDocumentToCloudinary = async (file) => {
  return uploadToCloudinary(file, "raw", 10);
};
 
/**
 * Upload video to Cloudinary
 * @param {File} file - The video file to upload
 * @returns {Promise<string>} - The secure URL of the uploaded video
 */
export const uploadVideoToCloudinary = async (file) => {
  return uploadToCloudinary(file, "video", 50);
};
 
 